import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asbsbtchemistry',
  templateUrl: './asbsbtchemistry.component.html',
  styleUrls: ['./asbsbtchemistry.component.scss']
})
export class AsbsbtchemistryComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
